import { api } from "@/lib/api"
import { WorkspaceStackedBarChart } from "./workspace-stacked-bar-chart"

export function AICopilotMessagesChart() {
	const query = api.analytics.aiCopilotMessagesChart.useQuery({})

	return (
		<WorkspaceStackedBarChart
			title="AI Assistant Messages"
			data={query.data}
			isLoading={query.isLoading}
		/>
	)
}
